import * as React from 'react';

import { clientConfig } from 'config/client';
import localStorage from 'core/local-storage/localStorage';

import { IProps } from './interfaces';

import styles from './PeopleDirectory.module.styl';

export default class PeopleDirectory extends React.Component<IProps> {
  private readonly frameRef: React.RefObject<any> = React.createRef();

  public componentDidMount() {
    this.frameRef.current.onload = () => {
      this.frameRef.current.contentWindow.postMessage(
        {
          payload: localStorage.get(clientConfig.tokenParamName),
          type: 'JWT',
        },
        '*',
      );
    };
  }

  public render() {
    return (
      <div className={styles.root}>
        {/* this has been added to trigger prod deploy */}
        <h1 style={{ display: 'none' }}>hidden</h1>
        <iframe
          ref={this.frameRef}
          id="people-directory"
          title="People Directory"
          className={styles.frame}
          src={this.getUrl()}
        />
      </div>
    );
  }

  private getUrl = () => {
    const { locale } = this.props.match.params;

    return `${clientConfig.peopleDirectoryHost}/pdui/${
      locale ? `${locale}` : 'en'
    }`;
  };
}
